export default defineNuxtRouteMiddleware((to, _from) => {
  const store = useStore()
  if (store.isSearchModalOpen || store.isMobileMenuOpen) return abortNavigation()
})
